// extracted by mini-css-extract-plugin
export var details = "_i3-0";
export var inspectorPopover = "_i3-1";